export type ReplayAutoplaySpeed = 'fast' | 'normal' | 'slow';

export const REPLAY_AUTOPLAY_SPEED_MS: Record<ReplayAutoplaySpeed, number> = {
  fast: 500,
  normal: 1000,
  slow: 3000,
};

export const REPLAY_AUTOPLAY_SPEED_OPTIONS: {
  value: ReplayAutoplaySpeed;
  label: string;
}[] = [
  { value: 'fast', label: '0.5 s' },
  { value: 'normal', label: '1 s' },
  { value: 'slow', label: '3 s' },
];

export const DEFAULT_REPLAY_AUTOPLAY_SPEED: ReplayAutoplaySpeed = 'fast';

const REPLAY_AUTOPLAY_SPEEDS = new Set<string>(
  Object.keys(REPLAY_AUTOPLAY_SPEED_MS),
);

export function normalizeReplayAutoplaySpeed(
  value: unknown,
): ReplayAutoplaySpeed {
  if (typeof value === 'string' && REPLAY_AUTOPLAY_SPEEDS.has(value)) {
    return value as ReplayAutoplaySpeed;
  }
  return DEFAULT_REPLAY_AUTOPLAY_SPEED;
}
